/**
 * Custom Menu Accordion Override
 * This script overrides the default MenuDrawer sliding behavior with accordion functionality
 */

(function () {
  'use strict';

  // Wait for DOM to be ready
  function initCustomMenuAccordion() {
    const menuDrawer = document.querySelector('menu-drawer');
    if (!menuDrawer) return;

    // Get all trigger buttons that open child menus
    const childListTriggers = menuDrawer.querySelectorAll('[data-ref="childListTrigger"]');

    // Override the default click behavior for child list triggers
    childListTriggers.forEach((button) => {
      // Remove existing event listeners by cloning the element
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      // Add our custom accordion behavior
      newButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Find the parent list item
        const parentListItem = this.closest('.menu-drawer__menu__list__item');
        if (!parentListItem) return;

        // Find the child menu within this parent
        const childMenu = parentListItem.querySelector('.menu-drawer__menu__list--child');
        if (!childMenu) return;

        // Toggle the accordion
        const isCurrentlyOpen = childMenu.classList.contains('menu-drawer__menu__list--child--active');

        if (isCurrentlyOpen) {
          // Close this accordion
          childMenu.classList.remove('menu-drawer__menu__list--child--active');
        } else {
          // Close any other open accordions at the same level
          const siblingAccordions = parentListItem.parentNode.querySelectorAll(
            '.menu-drawer__menu__list--child--active'
          );
          siblingAccordions.forEach((accordion) => {
            accordion.classList.remove('menu-drawer__menu__list--child--active');
          });

          // Open this accordion
          childMenu.classList.add('menu-drawer__menu__list--child--active');
        }
      });
    });

    // Handle third-level menus the same way
    const nestedTriggers = menuDrawer.querySelectorAll('.menu-drawer__menu__list--child [data-ref="childListTrigger"]');
    nestedTriggers.forEach((button) => {
      // Remove existing event listeners by cloning the element
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);

      // Add our custom accordion behavior for nested menus
      newButton.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Find the parent list item
        const parentListItem = this.closest('.menu-drawer__menu__list__item');
        if (!parentListItem) return;

        // Find the child menu within this parent
        const childMenu = parentListItem.querySelector('.menu-drawer__menu__list--child');
        if (!childMenu) return;

        // Toggle the nested accordion
        const isCurrentlyOpen = childMenu.classList.contains('menu-drawer__menu__list--child--active');

        if (isCurrentlyOpen) {
          // Close this accordion
          childMenu.classList.remove('menu-drawer__menu__list--child--active');
        } else {
          // Close any other open accordions at the same level
          const siblingAccordions = parentListItem.parentNode.querySelectorAll(
            '.menu-drawer__menu__list--child--active'
          );
          siblingAccordions.forEach((accordion) => {
            accordion.classList.remove('menu-drawer__menu__list--child--active');
          });

          // Open this accordion
          childMenu.classList.add('menu-drawer__menu__list--child--active');
        }
      });
    });

    // Disable the back/return buttons since we don't need them for accordions
    const returnButtons = menuDrawer.querySelectorAll('[data-ref="listReturn"]');
    returnButtons.forEach((button) => {
      button.style.display = 'none';
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomMenuAccordion);
  } else {
    initCustomMenuAccordion();
  }

  // Also reinitialize when menu drawer component is loaded (for async components)
  window.addEventListener('load', function () {
    setTimeout(initCustomMenuAccordion, 100); // Small delay to ensure components are loaded
  });
})();
